"use client"

import Link from "next/link"
import type { ComponentPropsWithoutRef, ReactNode } from "react"

import { trackMarketingCtaClick, type MarketingCtaPlacement } from "~/lib/gtag"

type MarketingCtaLinkProps = Omit<ComponentPropsWithoutRef<typeof Link>, "href" | "onClick"> & {
  href: string
  placement: MarketingCtaPlacement
  planTier?: string
  linkText?: string
  children: ReactNode
}

/**
 * Internal link that records a marketing CTA click before navigation.
 *
 * @param {MarketingCtaLinkProps} props - Link props plus analytics placement context.
 * @returns {JSX.Element} Tracked Next.js link.
 */
export function MarketingCtaLink({
  href,
  placement,
  planTier,
  linkText,
  children,
  ...linkProps
}: MarketingCtaLinkProps): JSX.Element {
  return (
    <Link
      href={href}
      onClick={() => {
        trackMarketingCtaClick({
          placement,
          destinationPath: href,
          planTier,
          linkText,
        })
      }}
      {...linkProps}
    >
      {children}
    </Link>
  )
}
